import { useParams } from "react-router-dom";
import i18n from "@/i18n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { EditCardWrapper } from "@/features/Edit/EditCardWrapper.tsx";
import { AuditCard } from "@/pages/a7/Audit/AuditCard";
import { a7FIACompositionsEditForm } from "@/pages/a7/EditForms/a7FIACompositionsEditForm.tsx";
import { getCompositionsAuditColumns } from "./columns";

export const A7FIACompositionsEdit = () => {
  const { id } = useParams<{ id: string }>();
  const { t, i18n: i18nClient } = useTranslation(["tables", "common"]);
  const auditColumns = useMemo(
    () => getCompositionsAuditColumns(t),
    [t, i18nClient.language],
  );

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="h-full bg-gray-50">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex justify-center">
          <EditCardWrapper
            client={"a7"}
            id={Number(id)}
            {...a7FIACompositionsEditForm}
            disable_translations_request={true}
          />
        </div>
        <AuditCard
          client={"a7"}
          id={Number(id)}
          name={a7FIACompositionsEditForm.table_name}
          audit_columns={auditColumns}
        />
      </div>
    </div>
  );
};
